import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';
import { Label, Ranking } from 'globals/store/events.data';
import { IconComponent } from '../icon/icon.component';
import { LabelItemComponent } from './label-item.component';

@Component({
    selector: 'labels-view',
    template: `
<div class="labels">
  <div class="sponsor-level-holder" *ngIf="sponsorType">
    <icon icon="sponsor18"></icon>
    <span class="sponsor-type">{{ sponsorType.name | uppercase }}</span>
  </div>
  <div class="lbl" *ngFor="let id of labels">
    <label-item *ngIf="labelMap && labelMap[id] as lbl" [color]="lbl.color" [label]="lbl.label"></label-item>
  </div>
  <ng-content></ng-content>
</div>
`,
    styleUrls: ['./labels-row.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, LabelItemComponent]
})
export class LabelsViewComponent {
  @Input() labelMap: { [id: string]: Label }
  @Input() labels: string[]
  @Input() sponsorType: Ranking
}




